import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';

interface PageTitleContextType {
  title: string;
  setTitle: (title: string) => void;
  subtitle: string;
  setSubtitle: (subtitle: string) => void;
}

const PageTitleContext = createContext<PageTitleContextType | undefined>(undefined);

export function PageTitleProvider({ children }: { children: ReactNode }) {
  const [title, setTitle] = useState<string>('eDocendo');
  const [subtitle, setSubtitle] = useState<string>('');

  return (
    <PageTitleContext.Provider value={{ title, setTitle, subtitle, setSubtitle }}>
      {children}
    </PageTitleContext.Provider>
  );
}

export function usePageTitle() {
  const context = useContext(PageTitleContext);
  if (context === undefined) {
    throw new Error('usePageTitle must be used within a PageTitleProvider');
  }
  return context;
}

export function useSetPageTitle(title: string, subtitle: string = '') {
  const { setTitle, setSubtitle } = usePageTitle();
  useEffect(() => {
    setTitle(title);
    setSubtitle(subtitle);
    return () => {
      // Optional: Reset on unmount if needed, but usually not required as next page overwrites
    };
  }, [title, subtitle, setTitle, setSubtitle]);
}
